<template>
  <PageShell class="page-shell-wrapper--pc" locale="id" :page-title="pageTitle">
    <PcContent />
  </PageShell>
</template>

<script>
import PageShell from '@/components/layout/PageShell.vue';
import PcContent from './PcContent.vue';

export default {
  name: 'PcPage',
  components: { PageShell, PcContent },
  computed: {
    pageTitle() {
      return this.$route.meta.pageTitle || '';
    },
  },
};
</script>
